<script setup lang="ts">

defineOptions({
  name: 'StepContainer'
})

interface StepContainerProps {
  slotPosition?: 'top' | 'bottom'
}

withDefaults(defineProps<StepContainerProps>(), {
  slotPosition: 'top',
})
</script>

<template>
  <div class="step-container">
    <div
      v-if="$slots.head"
      class="step-container__head"
    >
      <slot name="head" />
    </div>
    <div
      v-if="$slots.note"
      class="step-container__note"
    >
      <slot name="note" />
    </div>
    <div
      v-if="$slots.banner"
      class="step-container__banner"
    >
      <slot name="banner" />
    </div>
    <div
      v-if="$slots.default"
      class="step-container__box"
    >
      <slot />
    </div>
    <div
      v-if="$slots.submit"
      class="step-container__submit"
    >
      <slot name="submit" />
    </div>
    <div
      v-if="$slots.floatingSubmit"
      class="step-container__floating"
    >
      <div class="step-container__fixed">
        <slot name="floatingSubmit" />
      </div>
    </div>
    <div
      v-if="$slots.bottomContent"
      :class="slotPosition"
      class="step-container__bottom"
    >
      <slot name="bottomContent" />
    </div>
  </div>
</template>

<style lang="scss" src="@scss/layouts/StepContainer.scss" />
